import { type UseQueryOptions, useQueries } from '@tanstack/react-query';
import type { ItemHealth } from '@/common/api/types/dashboard/health';
import { insightsQueryKeys } from '@/features/insights/queryKeys';
import { HealthApi } from '@/features/insights-dashboard/api/health';
import { INSIGHTS_STALE_TIME } from '@/features/insights-dashboard/components/data/constants';

export const useItemHealthByItemId = (itemIds: number[]): Map<number, ItemHealth | undefined> =>
  useQueries({
    queries: itemIds.map(
      (id): UseQueryOptions<ItemHealth | undefined> => ({
        queryKey: insightsQueryKeys.health.byItemId(id),
        queryFn: async () => {
          const response = await HealthApi.getItemHealth({ itemIds: [id] });
          return response.data[0];
        },
        staleTime: INSIGHTS_STALE_TIME,
        refetchOnMount: 'always',
        refetchOnWindowFocus: 'always',
      }),
    ),
    combine: (results) => new Map(itemIds.map((id, itemIndex) => [id, results[itemIndex]?.data])),
  });
